import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Content } from 'ionic-angular';

import { Product } from '../../models/product';
import { DataProvider } from '../../providers/data/data';
import { PageBase } from '../page-base';
import { BasketProvider } from '../../providers/basket/basket';
import { ProductProvider } from '../../providers/product/product';
import { FavoriteProvider } from '../../providers/favorite/favorite';
import { BasketPage } from '../basket/basket';
import { CompanyConfigProvider } from '../../providers/company-config/company-config';

@IonicPage()
@Component({
  selector: 'page-detail',
  templateUrl: 'detail.html',
})
export class DetailPage extends PageBase {
  @ViewChild(Content) content: Content;	
  product: Product;
  isFavorite: boolean;

  showPrice: boolean;
  showOrder: boolean;

  constructor(
    private navCtrl: NavController,
    private productProvider: ProductProvider, 
    private basket: BasketProvider, 
    private navParams: NavParams, 
    private favoriteProvider: FavoriteProvider,
    private companyConfigProvider: CompanyConfigProvider) {
    super();
    this.product = this.navParams.get("product");
    this.product.quantity = this.basket.getProductQuantity(this.product.uuid);

    companyConfigProvider.canSeePrice().then(x => {
      this.showPrice = x;
    });

    companyConfigProvider.canSubmitOrder().then(x => {
      this.showOrder = x;
      this.content.resize();
    });

    favoriteProvider.isFavorite(this.product.uuid).then(x => {
      this.isFavorite = x;
    });
  }

  private updateFavorite() {
    if (this.isFavorite) {
      // Add product to favorites list
      this.favoriteProvider.addFavorite(this.product.uuid);
    } else {
      // Remove product from favorites list
      this.favoriteProvider.removeProduct(this.product.uuid);
    }
  }

  /**
  * Decreases the quantity of the specified product if the quantity is not 0
  * and updates totals.
  */
  private removeProduct() {
    if (this.product.quantity > 0) {
      this.product.quantity--;
      // Decrease product quantity in basket
      this.basket.decreaseProductQuantity(this.product.uuid);
    }
  }

  /**
  * Increases the quantity of the specified product and updates totals.
  */
  private addProduct() {
    this.product.quantity++;
    // Increase product quantity in basket
    this.basket.increaseProductQuantity(this.product.uuid);
  }

  /**
  * Shows a popup for setting the quantity for the specified product.
  */
  private setQuantity() {
    var q = "";
    if (this.product.quantity > 0) {
      q = this.product.quantity.toString();
    }
    this.alertProvider.showPrompt(this.product.name, q, (data) => {
      var qty: number = +data.quantity;
      if (qty > -1) {
        this.product.quantity = +data.quantity;
        this.basket.setProductQuantity(this.product.uuid, +data.quantity);
      }
    });
  }

  /**
  * Navigates to the basket page.
  */
  private navigateToBasket() {
    this.navCtrl.push(BasketPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts